export default __webpack_public_path__ + "static/media/deal.black.df6512bf.svg";